// import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
// import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
// const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
// const changedField = 'changed__time';

// const collator = new Intl.Collator();
// const sortByName = function (a, b) {
//     let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
//     if (cmp) {
//         return cmp;
//     }
//     return a.id - b.id;
// }

export default {
    state: {
    },
    actions: {
        fetchUserExtServices({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.userId) {
                    return reject(false)
                }
                const params = getApiProps('user-ext-services', args)
                delete params.userId;
                this.$api.userExtServices.find(args.userId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            //commit('updateUser', response.data)
                            resolve(response)
                        } else {
                            console.error(response);
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            });
        },
        fetchUserExtServicesFormControls({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.userId) {
                    return reject(false)
                }
                const params = getApiProps('user-ext-services', args)
                delete params.userId;
                this.$api.userExtServices.getServiceFormControls(args.userId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            //commit('updateUser', response.data)
                            resolve(response)
                        } else {
                            console.error(response);
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            });
        },
        updateUserExtService(_, userExtService) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('user-ext-services')
                this.$api.userExtServices.update(userExtService.id, userExtService, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            //
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        fetchUserExtServicesData({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.userId || !args.service) {
                    return reject(false)
                }
                const params = getApiProps('user-ext-services', args)
                delete params.userId;delete params.service;
                this.$api.userExtServices.getServiceData(args.userId, args.service, params)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            });
        },
        callUserExtServiceMethod({getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.service || !args.method) {
                    return reject(false)
                }
                const params = getApiProps('user-ext-services', args)
                delete params.userId;delete params.service;delete params.method;
                this.$api.userExtServices.callServiceMethod(args.userId, args.service, args.method, params)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            });
        },
    },
    mutations: {},
    getters: {}
}
